"use client";

import { useEffect } from "react";

const sanctumUrl = process.env.REACT_APP_API_ENDPOINT || "";

// Only call the CSRF cookie endpoint if the CSRF cookie is missing
export async function getCsrfCookie() {
  if (
    !document.cookie.split("; ").find((row) => row.startsWith("XSRF-TOKEN="))
  ) {
    return fetch(`${sanctumUrl}/sanctum/csrf-cookie`, {
      credentials: "include",
    });
  }
  // If already present, resolve immediately
  return Promise.resolve();
}

export const SanctumProvider = ({ children }) => {
  useEffect(() => {
    // Fetch the CSRF cookie on initial load to ensure it's available for subsequent requests
    getCsrfCookie();
  }, []);
  return <>{children}</>;
};
